import {Nullable} from "../../models/common/Nullable";
import {AllTimesheetListTypes} from "../../models/timesheet/Timesheet";
import {
    errorFetchingRequestState,
    getInitialRequestState,
    RequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";
import {
    CREATE_TIMESHEET_TASK,
    CREATE_TIMESHEET_TASK_ERROR,
    CREATE_TIMESHEET_TASK_SUCCESS,
    DELETE_TIMESHEET_TASK,
    DELETE_TIMESHEET_TASK_ERROR,
    DELETE_TIMESHEET_TASK_SUCCESS,
    FETCH_TIMESHEET_TASK,
    FETCH_TIMESHEET_TASK_ERROR,
    FETCH_TIMESHEET_TASK_SUCCESS,
    FETCH_TIMESHEET_TASKS,
    FETCH_TIMESHEET_TASKS_ERROR,
    FETCH_TIMESHEET_TASKS_SUCCESS,
    RESTORE_TIMESHEET_TASK,
    RESTORE_TIMESHEET_TASK_ERROR,
    RESTORE_TIMESHEET_TASK_SUCCESS,
    TimesheetTaskActionTypes,
    UPDATE_TIMESHEET_TASK,
    UPDATE_TIMESHEET_TASK_ERROR,
    UPDATE_TIMESHEET_TASK_SUCCESS
} from "../../actions/timesheet_tasks/TimesheetTasksActions";
import {TimesheetTask} from "../../models/timesheet/TimesheetTask";
import {TimesheetTaskPredefDescriptionActionTypes} from "../../actions/timesheet_tasks/TimesheetTaskPredefDescriptionActions";

export interface TimesheetTaskDetailState {
    task: Nullable< TimesheetTask >
}

export interface TimesheetTasksState {
    totalEntries: number
    entries: {
        current: Nullable<AllTimesheetListTypes>
        request: RequestState
    },
    detailedEntries: {
        [ key: number ]: TimesheetTaskDetailState
    },
    detailFetchRequest: RequestState
    changingRequest: RequestState
}

const initialState: TimesheetTasksState = {
    totalEntries: 0,
    entries: {
        current: null,
        request: getInitialRequestState()
    },
    detailedEntries: {},
    detailFetchRequest: getInitialRequestState(),
    changingRequest: getInitialRequestState()

};

export const TimesheetTasksReducer = (
    state = initialState,
    action: TimesheetTaskActionTypes | TimesheetTaskPredefDescriptionActionTypes
) => {
    switch( action.type ) {
        case FETCH_TIMESHEET_TASKS: {
            return {
                ...state,
                entries: {
                    request: startFetchingRequestState()
                }
            };
        }
        case FETCH_TIMESHEET_TASKS_SUCCESS: {
            return {
                ...state,
                totalEntries: action.payload.totalEntries,
                entries: {
                    current: action.payload.entries,
                    request: successFetchingRequestState()
                }
            };
        }
        case FETCH_TIMESHEET_TASKS_ERROR: {
            return {
                ...state,
                entries: {
                    ...state.entries,
                    request: errorFetchingRequestState( action.error )
                }
            };
        }
        case FETCH_TIMESHEET_TASK:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.timesheetTaskId.rawValue ]: {
                        task: null,
                        predefinedDescriptions: null,
                    }
                },
                detailFetchRequest: startFetchingRequestState()
            };
        case FETCH_TIMESHEET_TASK_SUCCESS: {
            const { rawValue: rawId } = action.timesheetTask.timesheetTaskId;

            if (!state.detailedEntries[rawId]) {
                throw Error("Detail entry undefined! You have to call fetchTimesheetTask first!");
            }

            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ rawId ]: {
                        ...state.detailedEntries[ rawId ],
                        task: action.timesheetTask,
                    }
                },
                detailFetchRequest: successFetchingRequestState()
            };
        }
        case FETCH_TIMESHEET_TASK_ERROR: {
            const { rawValue: rawId } = action.timesheetTaskId;

            if (!state.detailedEntries[rawId]) {
                throw Error("Detail entry undefined! You have to call fetchTimesheetTask first!");
            }

            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ rawId ]: {
                        ...state.detailedEntries[ rawId ],
                    }
                },
                detailFetchRequest: errorFetchingRequestState( action.error )
            };
        }
        case UPDATE_TIMESHEET_TASK:
        case DELETE_TIMESHEET_TASK:
        case RESTORE_TIMESHEET_TASK:
        case CREATE_TIMESHEET_TASK: {
            return {
                ...state,
                changingRequest: startFetchingRequestState()
            };
        }
        case UPDATE_TIMESHEET_TASK_SUCCESS:
        case DELETE_TIMESHEET_TASK_SUCCESS:
        case RESTORE_TIMESHEET_TASK_SUCCESS:
        case CREATE_TIMESHEET_TASK_SUCCESS: {
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.timesheetTask.timesheetTaskId.rawValue ]: {
                        task: action.timesheetTask
                    }
                },
                changingRequest: successFetchingRequestState()
            };
        }
        case UPDATE_TIMESHEET_TASK_ERROR:
        case DELETE_TIMESHEET_TASK_ERROR:
        case RESTORE_TIMESHEET_TASK_ERROR:
        case CREATE_TIMESHEET_TASK_ERROR: {
            return {
                ...state,
                changingRequest: errorFetchingRequestState( action.error )
            };
        }
        default:
            return state;
    }
};